import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AlertTriangle, PlusCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import useChatStore from '@/stores/useChatStore'
import { Skeleton } from '@/components/ui/skeleton'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { SessionHistoryItem } from '@/components/chat/SessionHistoryItem'

const SessionHistoryPage = () => {
  const { sessions, fetchSessions, startNewSession, isLoading, error } =
    useChatStore()
  const navigate = useNavigate()

  useEffect(() => {
    fetchSessions()
  }, [fetchSessions])

  const handleNewChat = () => {
    startNewSession()
    navigate('/')
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="space-y-4">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-32 w-full" />
          ))}
        </div>
      )
    }

    if (error) {
      return (
        <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Failed to load session history</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )
    }

    if (sessions.length > 0) {
      return (
        <div className="space-y-4">
          {sessions.map((session) => (
            <SessionHistoryItem key={session.id} session={session} />
          ))}
        </div>
      )
    }

    return (
      <div className="text-center py-16 border-2 border-dashed rounded-lg">
        <h3 className="text-xl font-semibold">No past sessions found.</h3>
        <p className="text-muted-foreground mt-2 mb-4">
          Start a new chat to see your history here.
        </p>
        <Button onClick={handleNewChat}>
          <PlusCircle className="mr-2 h-4 w-4" /> Start a New Chat
        </Button>
      </div>
    )
  }

  return (
    <div className="container max-w-4xl mx-auto py-8 px-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">Session History</h1>
        <Button onClick={handleNewChat}>
          <PlusCircle className="mr-2 h-4 w-4" /> New Chat
        </Button>
      </div>
      {renderContent()}
    </div>
  )
}

export default SessionHistoryPage
